import reducer from "./reducer";
import * as actions from "./actions";
import * as selectors from "./selectors";
import * as constants from "./constants";

export default {
  actions,
  constants,
  reducer,
  selectors,
};
